import { OnInit, AfterViewInit, EventEmitter, OnChanges } from '@angular/core';
import { ErrorHandlerService } from '../../../services';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from '../../../dashboard';
import { ConfirmationService } from 'primeng/primeng';
var QuestionnaireModalPopup = /** @class */ (function () {
    function QuestionnaireModalPopup(fb, errorHandlerService, dashboardService, confirmationService) {
        this.fb = fb;
        this.errorHandlerService = errorHandlerService;
        this.dashboardService = dashboardService;
        this.confirmationService = confirmationService;
        this.answerTypes = [
            "",
            "Text",
            "Radio",
            "Checkbox",
            "Dropdown",
            "Multiselect",
            "StarRating",
            "DateTime"
        ];
        this.subscriptions = [];
        this.isQuestionModalDialogToBeDisplayed = false;
        this.isCreatingSession = false;
        this.objId = 0;
        this.sessionId = 0;
        this.QuestionModalPopupClosed = new EventEmitter();
        this.questionnaireForm = this.fb.group({
            description: [null, [Validators.required]],
            questionnaireType: 1,
            questions: this.fb.array([]),
        });
        if ((this.objId == 0 || this.objId == null) && this.isQuestionModalDialogToBeDisplayed) {
            this.addQuestion();
        }
    }
    QuestionnaireModalPopup.prototype.questions = function () {
        return this.questionnaireForm.get("questions");
    };
    QuestionnaireModalPopup.prototype.newQuestion = function () {
        return this.fb.group({
            number: 1,
            question: [null, [Validators.required]],
            answerTypeCode: 1,
            options: this.fb.array([]),
            maxLength: [100, [Validators.required]],
            maxRating: [10, [Validators.required]],
            optional: true
        });
    };
    QuestionnaireModalPopup.prototype.addQuestion = function () {
        this.questions().push(this.newQuestion());
        setTimeout(function () {
            var div = document.getElementById("scrollDiv");
            if (div != null) {
                $('#scrollDiv').animate({
                    scrollTop: div.scrollHeight - div.clientHeight
                }, 250);
            }
        }, 150);
    };
    QuestionnaireModalPopup.prototype.removeQuestion = function (i) {
        this.questions().removeAt(i);
    };
    QuestionnaireModalPopup.prototype.getOptions = function (queIndex) {
        return this.questions().at(queIndex).get("options");
    };
    QuestionnaireModalPopup.prototype.newOption = function () {
        return this.fb.group({
            optionName: [null, [Validators.required]]
        });
    };
    QuestionnaireModalPopup.prototype.addOption = function (queIndex) {
        this.getOptions(queIndex).push(this.newOption());
    };
    QuestionnaireModalPopup.prototype.removeOption = function (queIndex, optionIndex) {
        this.getOptions(queIndex).removeAt(optionIndex);
    };
    QuestionnaireModalPopup.prototype.removeAllOptions = function (queIndex) {
        for (var index = 0; index < this.getOptions(queIndex).length; index++) {
            this.removeOption(queIndex, index);
        }
    };
    QuestionnaireModalPopup.prototype.answerTypeCodeChange = function (queIndex, val) {
        if (val != 1 && val != 6 && val != 7) {
            if (this.getOptions(queIndex).length == 0) {
                this.addOption(queIndex);
            }
        }
        else {
            this.removeAllOptions(queIndex);
        }
    };
    QuestionnaireModalPopup.prototype.ngOnChanges = function () {
        console.log("isCreatingSession", this.isCreatingSession);
        console.log("objId", this.objId);
        console.log("sessionId", this.sessionId);
        if (this.objId > 0 && this.isQuestionModalDialogToBeDisplayed) {
            this.getQuestionnaire(this.objId);
        }
        if ((this.objId == 0 || this.objId == null) &&
            this.isQuestionModalDialogToBeDisplayed &&
            this.questionnaireForm.value.questions.length == 0) {
            this.addQuestion();
        }
    };
    QuestionnaireModalPopup.prototype.ngOnInit = function () {
        console.log("isCreatingSession", this.isCreatingSession);
        console.log("objId", this.objId);
        console.log("sessionId", this.sessionId);
        if (this.objId > 0) {
            this.getQuestionnaire(this.objId);
        }
    };
    QuestionnaireModalPopup.prototype.getQuestionnaire = function (id) {
        var _this = this;
        var s2 = this.dashboardService.getQuestionnaire(id).subscribe(function (data) {
            _this.questionnaireForm.get("description").setValue(data.description);
            _this.questionnaireForm.get("questionnaireType").setValue(data.questionnaireType);
            for (var i = 0; i < data.questions.length; i++) {
                _this.questions().push(_this.fb.group({
                    number: data.questions[i].number,
                    question: [data.questions[i].question, [Validators.required]],
                    answerTypeCode: data.questions[i].answerTypeCode,
                    options: _this.fb.array([]),
                    maxLength: [data.questions[i].maxLength, [Validators.required]],
                    maxRating: [data.questions[i].maxRating, [Validators.required]],
                    optional: data.questions[i].optional
                }));
                if (data.questions[i].options != null && data.questions[i].options.length > 0) {
                    for (var j = 0; j < data.questions[i].options.length; j++) {
                        _this.getOptions(i).push(_this.fb.group({
                            optionName: [data.questions[i].options[j], [Validators.required]]
                        }));
                    }
                }
            }
            console.log("getQuestionnaire", data);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    QuestionnaireModalPopup.prototype.deleteQuestionnaire = function (id) {
        var _this = this;
        this.confirmationService.confirm({
            message: "Delete Questionnaire?",
            header: 'Confirmation?',
            icon: 'fa fa-question-circle',
            accept: function () {
                var s3 = _this.dashboardService.deleteQuestionnaire(id).subscribe(function (data) {
                    if (data.success) {
                        data.isdeleted = true;
                        _this.handleModalPopupClose(data);
                    }
                }, function (error) {
                    _this.handleError(error);
                });
                _this.subscriptions.push(s3);
            },
            reject: function () {
            }
        });
    };
    QuestionnaireModalPopup.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    QuestionnaireModalPopup.prototype.ngAfterViewInit = function () {
    };
    QuestionnaireModalPopup.prototype.getAnswerType = function (answerTypeCode) {
        return this.answerTypes[answerTypeCode];
    };
    QuestionnaireModalPopup.prototype.onSubmit = function () {
        var _this = this;
        if (this.questionnaireForm.valid) {
            for (var i = 0; i < this.questionnaireForm.value.questions.length; i++) {
                this.questionnaireForm.value.questions[i].number = i + 1;
                if (this.questionnaireForm.value.questions[i].answerTypeCode != 1) {
                    this.questionnaireForm.value.questions[i].maxLength = 0;
                }
                if (this.questionnaireForm.value.questions[i].answerTypeCode != 6) {
                    this.questionnaireForm.value.questions[i].maxRating = 0;
                }
                //this.questionnaireForm.value.questions[i].answerType = this.getAnswerType(this.questionnaireForm.value.questions[i].answerTypeCode);
                if (this.questionnaireForm.value.questions[i].options.length > 0) {
                    for (var j = 0; j < this.questionnaireForm.value.questions[i].options.length; j++) {
                        this.questionnaireForm.value.questions[i].options[j] = this.questionnaireForm.value.questions[i].options[j].optionName;
                    }
                }
                else {
                    this.questionnaireForm.value.questions[i].options = null;
                }
            }
            if (!this.isCreatingSession && this.sessionId > 0) {
                this.questionnaireForm.value.questionnaireTargetId = this.sessionId;
            }
            if (this.objId > 0) {
                this.questionnaireForm.value.objId = this.objId;
                var s2 = this.dashboardService.updateQuestionnaire(this.questionnaireForm.value).subscribe(function (data) {
                    if (data.success) {
                        _this.handleModalPopupClose(data);
                    }
                }, function (error) {
                    _this.handleError(error);
                });
                this.subscriptions.push(s2);
            }
            else {
                var s1 = this.dashboardService.addQuestionnaire(this.questionnaireForm.value).subscribe(function (data) {
                    if (data.success) {
                        _this.handleModalPopupClose(data);
                    }
                }, function (error) {
                    _this.handleError(error);
                });
                this.subscriptions.push(s1);
            }
            console.log(this.questionnaireForm.value);
        }
        else {
            this.validateAllFields(this.questionnaireForm);
            this.validateAllFields(this.questionnaireForm.get("questions"));
            for (var q = 0; q < this.questions().length; q++) {
                for (var index = 0; index < this.getOptions(q).length; index++) {
                    this.validateAllFields(this.questions().at(q).get("options"));
                }
            }
        }
    };
    QuestionnaireModalPopup.prototype.validateAllFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                _this.validateAllFields(control);
            }
        });
    };
    QuestionnaireModalPopup.prototype.showModalDialog = function () {
        if (this.isQuestionModalDialogToBeDisplayed === true) {
            return "block";
        }
        else {
            return "none";
        }
    };
    QuestionnaireModalPopup.prototype.handleModalPopupClose = function (res) {
        this.isQuestionModalDialogToBeDisplayed = false;
        this.questionnaireForm.setControl('questions', this.fb.array([]));
        this.questionnaireForm.reset();
        this.QuestionModalPopupClosed.emit(res);
    };
    QuestionnaireModalPopup.prototype.handleEscape = function () {
        if (this.isQuestionModalDialogToBeDisplayed == true) {
            this.handleModalPopupClose(false);
        }
    };
    QuestionnaireModalPopup.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>");
        console.log(error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return QuestionnaireModalPopup;
}());
export { QuestionnaireModalPopup };
//# sourceMappingURL=questionnaire.component.js.map